import '../../sass/layout/page/page-news-entry.scss';


import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay,  EffectFade} from 'swiper/modules';

const mainCarousel = document.querySelector('.main-carousel');

if(mainCarousel) {
    const pagination = mainCarousel.querySelector('.swiper-pagination');
    const prevEl = mainCarousel.querySelector('.swiper-button-prev');
    const nextEl = mainCarousel.querySelector('.swiper-button-next');
    const swiper = new Swiper(mainCarousel, {
        modules: [Pagination, Navigation, Autoplay, EffectFade],
        loop: false,
        speed: 1200,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: pagination,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
    })  
}


const itemCategory = document.querySelectorAll('.product-box');
Array.prototype.forEach.call(itemCategory, item => {
    let link = item.querySelector('a');
    item.style.cursor = 'pointer';
    item.onmouseup = () => {
        link.click();
    }
});

const sectionNews = document.querySelector('.section-news');

if(sectionNews) {
    const prevEl = sectionNews.querySelector('.swiper-button-prev');
    const nextEl = sectionNews.querySelector('.swiper-button-next');
    const swiperCarousel = sectionNews.querySelector('.swiper');
    const swiper = new Swiper(swiperCarousel, {
        modules: [Navigation, Autoplay],
        loop: false,
        speed: 1200,
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
    })  
}
